import React from "react";
import PropTypes from "prop-types";
import GarmentPrice from "../GarmentPrice";
import { H2, UL, H4 } from "../Type";

const PriceList = ({ priceGroups }) => (
  <div>
    <H2>Our pricelist</H2>
    {priceGroups.map(([name, prices]) => (
      <div key={name}>
        <H4>{name}</H4>
        <UL>
          {prices.map(price => {
            return (
              <li key={price.id}>
                <GarmentPrice {...price} />
              </li>
            );
          })}
        </UL>
      </div>
    ))}
  </div>
);

PriceList.propTypes = {
  priceGroups: PropTypes.arrayOf(PropTypes.array).isRequired
};

export default PriceList;
